<template>
  <div class="solution">
    <!-- 顶部 banner -->
    <div class="banner">
      <div class="banner-inner">
        <h1 class="banner-title aw-anim">定制化平台开发与系统集成</h1>
        <p class="banner-desc aw-anim">依托云稼统一数字基座，提供全栈定制开发、多端应用搭建与异构系统集成服务，一站式解决政企个性化数字化建设难题</p>
        <button class="banner-btn aw-anim" @click="onConsult">
          立即咨询
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <!-- 方案简介 -->
    <section class="intro-section">
      <h2 class="section-title aw-anim">方案简介</h2>
      <div class="intro-body">
        <div class="intro-img">
          <img :src="introImg" alt="方案配图" />
        </div>
        <div class="intro-text aw-anim">
          <p>{{ introText }}</p>
        </div>
      </div>
    </section>

    <!-- 行业痛点 -->
    <section class="pain-section">
      <h2 class="section-title aw-anim">行业痛点</h2>
      <div class="pain-grid">
        <div class="pain-card aw-anim" v-for="(item, index) in painPoints" :key="index">
          <img class="pain-icon" :src="item.icon" :alt="item.title" />
          <h3 class="pain-title">{{ item.title }}</h3>
          <p class="pain-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 核心能力 -->
    <section class="cap-section">
      <h2 class="section-title aw-anim">核心能力</h2>
      <div class="cap-grid">
        <div class="cap-card aw-anim" :class="{ featured: item.featured }" v-for="(item, index) in capabilities"
          :key="index">
          <img class="cap-icon" :src="item.icon" :alt="item.title" />
          <h3 class="cap-title">{{ item.title }}</h3>
          <p class="cap-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 客户价值 -->
    <section class="value-section">
      <h2 class="section-title aw-anim">客户价值</h2>
      <div class="value-body">
        <div class="value-text aw-anim">
          <p>{{ valueText }}</p>
        </div>
        <div class="value-img">
          <img :src="valueImg" alt="客户价值全景" />
        </div>
      </div>
    </section>
    <!-- 在线留言 -->
    <ContactMessageForm />
  </div>
</template>

<script>
import ContactMessageForm from "@/components/ContactMessageForm.vue";

export default {
  name: "SolutionPage8",
  components: { ContactMessageForm },
  data() {
    return {
      introImg: require("@/assets/solution/customDev/intro_mock.png"),
      valueImg: require("@/assets/solution/customDev/value_mock.png"),
      introText: "依托云稼统一数字基座与成熟技术架构，为政府、企事业单位提供全栈式定制化数字化开发服务，涵盖平台架构搭建、业务系统定制、多端应用开发、第三方系统集成、私有化部署运维全流程。基于分层解耦设计，可按需适配各类农业及泛数字化项目，支持个性化需求快速落地",
      valueText: "完全贴合个性化业务需求，规避标准化产品的适配短板；实现多端数据互通、系统联动，提升整体数字化协同能力；专业部署运维保障系统安全稳定运行，降低长期数字化建设成本",
      painPoints: [
        {
          icon: require("@/assets/solution/customDev/sol_isol_pain1.png"),
          title: "产品适配受限",
          desc: "标准化产品无法适配企业、政府个性化业务流程与管理需求",
        },
        {
          icon: require("@/assets/solution/customDev/sol_isol_pain2.png"),
          title: "集成难度大",
          desc: "现有老旧系统独立运行，无法互联互通，系统集成难度大",
        },
        {
          icon: require("@/assets/solution/customDev/sol_isol_pain3.png"),
          title: "数据不互通",
          desc: "多端应用不统一，数据无法互通，用户操作体验差",
        },
        {
          icon: require("@/assets/solution/customDev/sol_isol_pain4.png"),
          title: "运维能力不足",
          desc: "项目部署、数据安全、后期运维缺乏专业保障",
        }
      ],
      capabilities: [
        {
          icon: require("@/assets/solution/customDev/sol_cap1.png"),
          title: "全栈定制开发",
          desc: "基于Java SpringBoot、UniApp成熟技术栈，定制各类业务系统、管理平台",
          featured: true,
        },
        {
          icon: require("@/assets/solution/customDev/sol_cap2.png"),
          title: "多端一体化开发",
          desc: "管理后台、小程序、H5、移动端APP、数据可视化大屏、GIS孪生页面",
          featured: false,
        },
        {
          icon: require("@/assets/solution/customDev/sol_cap4.png"),
          title: "系统集成对接",
          desc: "第三方API接口对接、老旧系统迭代升级、数据互通、业务联动",
          featured: false,
        },
        {
          icon: require("@/assets/solution/customDev/sol_cap3.png"),
          title: "架构优化升级",
          desc: "分层解耦架构改造、业务流程优化、权限体系定制",
          featured: false,
        },
        {
          icon: require("@/assets/solution/customDev/sol_cap5.png"),
          title: "部署运维服务",
          desc: "私有化部署、云端部署、数据安全防护、操作培训、终身运维",
          featured: false,
        }
      ],
    };
  },
  methods: {
    onConsult() {
      const el = document.getElementById("message-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.hash = "#message-section";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.solution {
  width: 100%;
  background: #ffffff;
}

/* ============ 顶部 banner ============ */
.banner {
  width: 100%;
  height: 564px;
  background-image: url("~@/assets/solution/customDev/banner.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-inner {
  width: 1196px;
  margin: 0 auto;
  padding-top: 150px;
  font-size: 0;
}

.banner-title {
  font-size: 44px;
  font-weight: 700;
  color: #2e6be6;
  margin: 0 0 12px;
}

.banner-desc {
  width: 610px;
  font-size: 18px;
  line-height: 31px;
  color: #333333;
  margin: 0 0 80px;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 28px;
  background: #3982f7;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2e6be6;
  }

  .btn-arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
}

/* ============ 公共标题 ============ */
.section-title {
  margin-bottom: 40px;
  text-align: center;
  line-height: 32px;
}

/* ============ 方案简介 ============ */
.intro-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.intro-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.intro-img {
  //   flex: 0 0 518px;

  img {
    width: 558px;
    height: 348px;
    display: block;
  }
}

.intro-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

/* ============ 行业痛点 ============ */
.pain-section {
  padding: 80px 0;
  background: #ffffff;
}

.pain-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.pain-card {
  background: #f5f8fe;
  border-radius: 12px;
  //   padding: 44px 28px;/
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   justify-content: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  padding: 32px 24px 12px 32px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }
}

.pain-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.pain-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 16px;
  line-height: 20px;
}

.pain-desc {
  font-size: 16px;
  line-height: 28px;
  color: #666;
  margin: 0;
  text-align: justify;
  text-align-last: center;
}

/* ============ 核心能力 ============ */
.cap-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.cap-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.cap-card {
  grid-column: span 2;
  background: #ffffff;
  //   border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 32px 24px 0 32px;
  display: flex;
  flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  height: 250px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }

  /* 前两张各占半行 */
  &:nth-child(1),
  &:nth-child(2) {
    grid-column: span 3;
  }

  /* 第一张：蓝色渐变底 */
  &.featured {
    border: none;
    background: url("~@/assets/solution/bg1.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.cap-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.cap-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin: 0 0 16px;
}

.cap-desc {
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin: 0;
}

/* ============ 客户价值 ============ */
.value-section {
  padding: 80px 0;
  background: #ffffff;
}

.value-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.value-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

.value-img {
  img {
    width: 518px;
    height: 324px;
    display: block;
  }
}
</style>